'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProBanner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProBanner() {
  return _react2.default.createElement(
    'section',
    { className: 'ProBanner' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'text' },
        _react2.default.createElement(
          'h1',
          null,
          'Caligram Pro'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Diffusez facilement et efficacement les \xE9v\xE9nements de votre organisation.'
        ),
        _react2.default.createElement(_.RoundedButton, { title: 'En savoir plus', iconRight: 'chevronRight', href: 'http://pro.caligram.com' })
      ),
      _react2.default.createElement('img', { src: '/caligram-pro.svg', alt: '' })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProBanner.js
// module id = 1084
// module chunks = 0